import { PrismicLink } from "@prismicio/react";

const Cta = ({ color, justify, field }) => {
  return (
    <div className={`lg:min-h-[50px] flex items-center md:items-start ${justify} `}>
      <PrismicLink field={field} className={`cta cta-${color} cta-text`}>
      </PrismicLink>
    </div>
  );
};

export default Cta;